/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Empty_State_Hint_CreateInputs */

const en_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click the + button to create your first issue`)
};

const fr_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez sur le bouton + pour creer votre premier incident`)
};

const de_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicken Sie auf die Schaltfläche „+“, um Ihre erste Ausgabe zu erstellen.`)
};

const it_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicca sul pulsante + per creare il tuo primo numero`)
};

const ru_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите кнопку «+», чтобы создать свой первый выпуск.`)
};

const es_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga clic en el botón + para crear su primer número`)
};

const zh_cn2_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击“+”按钮创建您的第一个问题`)
};

const ja_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の問題を作成するには+ボタンをクリックしてください`)
};

const hi_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना पहला अंक बनाने के लिए + बटन पर क्लिक करें।`)
};

const pt_pt2_manual_qc_empty_state_hint_create = /** @type {(inputs: Manual_Qc_Empty_State_Hint_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique no botão + para criar sua primeira edição.`)
};

/**
* | output |
* | --- |
* | "Click the + button to create your first issue" |
*
* @param {Manual_Qc_Empty_State_Hint_CreateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_empty_state_hint_create = /** @type {((inputs?: Manual_Qc_Empty_State_Hint_CreateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Empty_State_Hint_CreateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_empty_state_hint_create(inputs)
	if (locale === "de") return de_manual_qc_empty_state_hint_create(inputs)
	if (locale === "it") return it_manual_qc_empty_state_hint_create(inputs)
	if (locale === "ru") return ru_manual_qc_empty_state_hint_create(inputs)
	if (locale === "es") return es_manual_qc_empty_state_hint_create(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_empty_state_hint_create(inputs)
	if (locale === "ja") return ja_manual_qc_empty_state_hint_create(inputs)
	if (locale === "hi") return hi_manual_qc_empty_state_hint_create(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_empty_state_hint_create(inputs)
	return en_manual_qc_empty_state_hint_create(inputs)
});